import AbsComponent from './AbsComponent';
import Utils from './Utils';

class AbsSection extends AbsComponent {

    constructor(_name='', _store={}, _el='') {
        super(_name, _store, _el);
        this.section = $(_el);
        if (this.section.length<1) {
            return false;
        }
        this.moviepath = this.store.getState().config.moviePath;
        this.nextSecName = '';
        this.$win = $( window );
        this.videoList = {};
        this.setting();
        this.addEvents();


        let watch = this.watch(this.store.getState, 'nowpage', this.isEqual);
        this.store.subscribe( watch( (newVal, oldVal, path) => {
            if (this.name === oldVal) {
                // console.log( 'old', this.name, oldVal, '----------------------------------------------> ', newVal );
                this.nextSecName = newVal;
                this.end();
            }
        }));
    }

    titleAni () {}

    setAniObj () {
        let scrTop = -Math.round((this.$win.height()-this.videoList.loop.height)/2);
        let scrLeft = -Math.round((this.$win.width()-this.videoList.loop.width)/2);
        TweenMax.set(this.drag.scrollProxy, { 
            scrollLeft: (scrLeft<0? 0: scrLeft), 
            scrollTop: (scrTop<0? 0: scrTop)
        });
    }

    start(_old, _new){
        // console.log(`------------ start : ${this.name} --------------`);
        $(this.el).show();
        this.titleAni();
    }

    end(){
        // console.log(`------------ end : ${this.name} --------------`);
        let scrTop = -Math.round((this.$win.height()-this.videoList.loop.height)/2);
        let scrLeft = -Math.round((this.$win.width()-this.videoList.loop.width)/2);
        TweenMax.to(this.drag.scrollProxy, 0.6, { 
            scrollLeft: (scrLeft<0? 0: scrLeft), 
            scrollTop: (scrTop<0? 0: scrTop), 
            ease: Quint.easeOut
        });
    }

    transitionEnd(){
        this.reset();
        $('#container').trigger('sec.end', [this.name, this.nextSecName]);
    }

    reset(){
        this.setAniObj ();
        $(this.el).hide();
    }

    vidioReset(_vidio, _zindex=0, _isShow=false){
        _vidio.setZindex(_zindex);
        _vidio.node.toggle(_isShow);
        return _vidio;
    }
}

export default AbsSection;